import React, { useState } from "react";

import {
  Checkbox,
  TableRow,
  TableCell,
  Typography,
  Paper,
  Box,
} from "@material-ui/core";

import { Entitlement } from "./types";
import {
  ShieldCheckmarkIcon,
  CustomerInsightsManagerIcon,
} from "./../components/icons/themes/windows10";
import { saasDestinations } from "../destinations/destinations";

type EntitlementAccessProps = {
  entitlements: Entitlement[];
  onRowAccessChange: (entitlement_id: string, checked: boolean) => void;
};

export const EntitlementAccess = ({
  entitlements,
  onRowAccessChange,
}: EntitlementAccessProps) => {
  const [entitlementAccess, setEntitlementAccess] = useState<Entitlement[]>(
    entitlements
  );
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [selectAllHipaa, setSelectAllHipaa] = useState<boolean>(false);

  const handleRowChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedEntitlements = entitlementAccess.map((i) => {
      if (i.entitlement_id === e.target.value) {
        return {
          ...i,
          has_access: e.target.checked,
        };
      }
      return i;
    });
    setEntitlementAccess(updatedEntitlements);
  };

  const onSelectAllChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedEntitlements = entitlementAccess.map((i) => {
      const updatedAccess = {
        ...i,
        has_access: e.target.checked,
      };
      onRowAccessChange(i.entitlement_id, e.target.checked);
      return updatedAccess;
    });
    setSelectAll(e.target.checked);
    if (!e.target.checked) {
      setSelectAllHipaa(false);
    }
    setEntitlementAccess(updatedEntitlements);
  };

  const onSelectHipaaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedEntitlements = entitlementAccess.map((i) => {
      if (i.hipaa_mode) {
        const updatedAccess = {
          ...i,
          has_access: e.target.checked,
        };
        onRowAccessChange(i.entitlement_id, e.target.checked);
        return updatedAccess;
      }
      return i;
    });
    setSelectAllHipaa(e.target.checked);
    setEntitlementAccess(updatedEntitlements);
  };

  const getIconForDestination = (destinationName: string) => {
    for (const entry of Object.entries(saasDestinations)) {
      const destination = entry[1];
      if (destinationName === destination.name) {
        const Icon = destination.logoSquare;
        return <Icon height={28} width={28} />;
      }
    }
    return <CustomerInsightsManagerIcon />;
  };

  return (
    <>
      <TableRow>
        <TableCell></TableCell>
        <TableCell>
          <Paper elevation={0} className="flex gap-x-10 justify-end">
            <Box display="flex" alignItems="center">
              <Checkbox
                checked={selectAll}
                color="secondary"
                edge="start"
                onChange={onSelectAllChange}
                value="selectAll"
              />
              <Typography component="h6">All</Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <Checkbox
                checked={selectAllHipaa}
                color="secondary"
                edge="start"
                onChange={onSelectHipaaChange}
                value="selectAllHipaa"
              />
              <Typography component="h6">HIPAA Mode</Typography>
            </Box>
          </Paper>
        </TableCell>
        <TableCell align="right" width="5%"></TableCell>
      </TableRow>

      {entitlementAccess.map((i) => (
        <TableRow key={`destination-access-row-${i.entitlement_id}`}>
          <TableCell>
            <Box display="flex" alignItems="center">
              {getIconForDestination(i.entitlement_name)}
              <Typography variant="h6" className="pl-4">
                {i.entitlement_name}
              </Typography>
              {i.hipaa_mode && <ShieldCheckmarkIcon className="ml-2" />}
            </Box>
          </TableCell>
          <TableCell align="right">
            <Checkbox
              checked={i.has_access}
              color="secondary"
              edge="start"
              onChange={(e) => {
                onRowAccessChange(i.entitlement_id, e.target.checked);
                handleRowChange(e);
              }}
              value={i.entitlement_id}
            />
          </TableCell>
          <TableCell align="right" width="5%"></TableCell>
        </TableRow>
      ))}
    </>
  );
};
